export const BRAND = {
  name: "La Boutique d'Esther",
  slogan: "L'élégance qui vous ressemble",
  whatsappNumber: "590690351493",
  whatsappDisplay: "+590 690 35 14 93",
  email: "contact@laboutiquedesther.gp",
  instagram: "https://instagram.com/laboutiquesther",
  instagramHandle: "@laboutiquesther",
  facebook: "https://facebook.com/laboutiquedesther",
};

export const waLink = (msg) =>
  `https://wa.me/${BRAND.whatsappNumber}?text=${encodeURIComponent(msg || "Bonjour La Boutique d'Esther ! Je souhaite commander / avoir des informations sur...")}`;

export const eur = (n) => `${Number(n).toFixed(2).replace('.', ',')} €`;
